module.exports = __webpack_public_path__ + "img/防伪溯源.976d4294.png";